export default function openFileInNewTab(blob: Blob) {
  const blobUrl = URL.createObjectURL(blob);

  window.open(blobUrl, '_blank');
  URL.revokeObjectURL(blobUrl);
}
